'use client';

import React from 'react';

import { useDomainConfiguration } from '@/components/DomainConfigurationProvider';

import { cn } from '@cineamo/ui/src/helpers/cn';

/**
 * Renders the operator-configured custom banner as a movable section of the page. Renders nothing when there is no
 * banner or no image is configured.
 */
const CustomBannerSlot: React.FC = () => {
    const { domainConfiguration } = useDomainConfiguration();
    const banner = domainConfiguration.customBanner;

    if (!banner) {
        return null;
    }

    const { imageUrlDesktop, imageUrlMobile, link, imageDescription } = banner;

    if (!imageUrlDesktop && !imageUrlMobile) {
        return null;
    }

    const altText = imageDescription ?? '';

    const bannerImage = (
        <div className="overflow-hidden rounded-16">
            {imageUrlDesktop && (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                    src={imageUrlDesktop}
                    alt={altText}
                    className={cn('w-full', imageUrlMobile && 'hidden lg:block')}
                />
            )}
            {imageUrlMobile && (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                    src={imageUrlMobile}
                    alt={altText}
                    className={cn('w-full', imageUrlDesktop && 'lg:hidden')}
                />
            )}
        </div>
    );

    return (
        <section>
            {link ? (
                <a
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block transition-opacity hover:opacity-90">
                    {bannerImage}
                </a>
            ) : (
                bannerImage
            )}
        </section>
    );
};

export default CustomBannerSlot;
